module.exports = __webpack_public_path__ + "static/media/front-logo.376f863e.png";